import styled from "styled-components"
import { BreakPoints, media } from "../../helpers/rwd"
import {
  SlideContentInfoStyles,
  ButtonsListStyle, ButtonWrapperStyle, DescriptionStyle,
  FullSizeSliderWrapperStyle,
  FullSizeSlideWrapperStyle,
  SlideContentWrapperStyle,
  TitleStyle,
  SlideHeaderLogoStyled
} from "./full-size-slider-styles"

export const FullSizeSliderWrapper = styled.div`
  width: 100%;
  ${FullSizeSliderWrapperStyle}
  .slick-slider .slick-slide {
    padding: 0;
    ${media.max(BreakPoints.lgDesktop)} {
      padding: 0;
    }
    ${media.max(BreakPoints.phone)} {
      padding: 0;
    }
  }
`;

interface FullSizeSlideWrapperProps {
  gradientStart: string;
  gradientEnd: string;
}
export const FullSizeSlideWrapper = styled.div<FullSizeSlideWrapperProps>`
  width: 100%;
  background: linear-gradient(${props => props.gradientStart+", "+props.gradientEnd});
  display: flex;
  justify-content: center;
  ${FullSizeSlideWrapperStyle}
`;

export const SlideContentInfo = styled.div`
  ${media.max(BreakPoints.smallDesktop)} {
    height: 100%;
    justify-content: end;
  }
  ${SlideContentInfoStyles}
`

interface SlideContentWrapperProps {
  imgSrc: string;
  imgSrcLaptop: string;
  imgSrcTablet: string;
  imgSrcMobile: string;
}
export const SlideContentWrapper = styled.div<SlideContentWrapperProps>`
  background: url(${props => props.imgSrc});
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  ${media.max(BreakPoints.desktop)} {
    background: url(${props => props.imgSrcLaptop});
    background-position: center center;
  }
  ${media.max(BreakPoints.desktop)} {
    background: url(${props => props.imgSrcLaptop ? props.imgSrcLaptop : props.imgSrc});
  }
  ${media.max(BreakPoints.smallDesktop)} {
    background: url(${props => props.imgSrcTablet ? props.imgSrcTablet : props.imgSrc});
  }
  ${media.max(BreakPoints.tablet)} {
    background: url(${props => props.imgSrcMobile ? props.imgSrcMobile : props.imgSrc});
  }
  ${SlideContentWrapperStyle}
`

export const ButtonsList = styled.div`
  display: flex;
  ${ButtonsListStyle}
`

export const ButtonWrapper = styled.div`
  ${ButtonWrapperStyle}
`

export const Title = styled.h1`
  ${media.max(BreakPoints.smallDesktop)} {
    margin-top: auto;
  }
  ${media.max(BreakPoints.tablet)} {
    font-size: 2rem;
  }
  ${media.max(BreakPoints.phone)} {
    font-size: 1.8rem;
  }
  ${TitleStyle}
`

export const Description = styled.span`
  ${media.max(BreakPoints.tablet)} {
    font-size: 1.5rem;
  }
  ${media.max(BreakPoints.phone)} {
    font-size: 1.3rem;
  }
  ${DescriptionStyle}
`

export const SlideHeaderLogo = styled.img`
  ${SlideHeaderLogoStyled}
`
